import { t } from "ttag";

import { getCartesianChartDefinition } from "metabase/visualizations/visualizations/CartesianChart/definition";
import {
  GRAPH_AXIS_SETTINGS,
  GRAPH_BUBBLE_SETTINGS,
  GRAPH_COLORS_SETTINGS,
  GRAPH_DATA_SETTINGS,
  GRAPH_GOAL_SETTINGS,
  GRAPH_TREND_SETTINGS,
  LEGEND_POSITION_SETTINGS,
  SPLIT_PANELS_SETTINGS,
  TIMELINE_EVENTS_SETTINGS,
  TOOLTIP_SETTINGS,
  type VisualizationDefinition,
  getDefaultSize,
  getMinSize,
} from "metabase/viz-core";

const ScatterViz: Omit<
  VisualizationDefinition,
  "isSensible" | "checkRenderable"
> = {
  getUiName: () => t`Scatter`,
  identifier: "scatter",
  iconName: "bubble",
  get noun() {
    return t`scatter plot`;
  },
  minSize: getMinSize("scatter"),
  defaultSize: getDefaultSize("scatter"),
  settings: {
    ...GRAPH_BUBBLE_SETTINGS,
    ...GRAPH_GOAL_SETTINGS,
    ...GRAPH_TREND_SETTINGS,
    ...GRAPH_COLORS_SETTINGS,
    ...GRAPH_AXIS_SETTINGS,
    ...LEGEND_POSITION_SETTINGS,
    ...GRAPH_DATA_SETTINGS,
    ...SPLIT_PANELS_SETTINGS,
    ...TOOLTIP_SETTINGS,
    ...TIMELINE_EVENTS_SETTINGS,
  },
};

export const SCATTER_PLOT_DEFINITION = getCartesianChartDefinition(ScatterViz);
